/**
 * @generated SignedSource<<bcb8130dea12cbfd4508b0587d29b1ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AncestryRelationship = "ANCESTOR" | "DESCENDANT" | "DIRECT_REPORT" | "MANAGER" | "OTHER" | "SELF" | "SIBLING";
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
export type MeetingSelectQuery$variables = {
  end?: string | null;
  guid?: string | null;
  nextOccurrencesCount?: number | null;
  oneOnOne?: string | null;
  oneOnOneOnly?: boolean | null;
  query?: string | null;
  recurring?: boolean | null;
  start?: string | null;
};
export type MeetingSelectQuery$data = {
  readonly events: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly attendees: ReadonlyArray<{
          readonly email: string;
          readonly fullName: string | null;
          readonly image: string | null;
          readonly user: {
            readonly email: string;
            readonly firstName: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly internalAttributes: {
              readonly manager: {
                readonly email: string;
                readonly firstName: string;
                readonly fullName: string;
                readonly id: string;
                readonly image: string;
                readonly isGuest: boolean;
                readonly lastName: string;
                readonly relationshipToViewer: AncestryRelationship | null;
              } | null;
            } | null;
            readonly isGuest: boolean;
            readonly lastName: string;
            readonly relationshipToViewer: AncestryRelationship | null;
          } | null;
        } | null>;
        readonly end: string | null;
        readonly guid: string;
        readonly hasNote: boolean;
        readonly id: string;
        readonly start: string | null;
        readonly title: string;
        readonly type: EventType;
      };
    } | null>;
  };
};
export type MeetingSelectQuery = {
  response: MeetingSelectQuery$data;
  variables: MeetingSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "end"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nextOccurrencesCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "oneOnOne"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "oneOnOneOnly"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recurring"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v8 = [
  {
    "kind": "Variable",
    "name": "end",
    "variableName": "end"
  },
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  },
  {
    "kind": "Variable",
    "name": "nextOccurrencesCount",
    "variableName": "nextOccurrencesCount"
  },
  {
    "kind": "Variable",
    "name": "oneOnOne",
    "variableName": "oneOnOne"
  },
  {
    "kind": "Variable",
    "name": "oneOnOneOnly",
    "variableName": "oneOnOneOnly"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Variable",
    "name": "recurring",
    "variableName": "recurring"
  },
  {
    "kind": "Variable",
    "name": "start",
    "variableName": "start"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNote",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationshipToViewer",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "manager",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    (v20/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v22/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "attendees",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "MeetingSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "EventConnection",
        "kind": "LinkedField",
        "name": "events",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attendee",
                    "kind": "LinkedField",
                    "name": "attendees",
                    "plural": true,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f11bc935faecd948db3b8de8b59faaa1",
    "id": null,
    "metadata": {},
    "name": "MeetingSelectQuery",
    "operationKind": "query",
    "text": "query MeetingSelectQuery(\n  $start: DateTime\n  $end: DateTime\n  $query: String\n  $recurring: Boolean\n  $oneOnOne: ID\n  $guid: String\n  $nextOccurrencesCount: Int\n  $oneOnOneOnly: Boolean\n) {\n  events(start: $start, end: $end, query: $query, recurring: $recurring, oneOnOne: $oneOnOne, guid: $guid, nextOccurrencesCount: $nextOccurrencesCount, oneOnOneOnly: $oneOnOneOnly) {\n    edges {\n      node {\n        id\n        guid\n        title\n        start\n        end\n        type\n        hasNote\n        attendees {\n          email\n          image\n          fullName\n          user {\n            id\n            fullName\n            firstName\n            lastName\n            email\n            image\n            relationshipToViewer\n            isGuest\n            internalAttributes {\n              manager {\n                id\n                fullName\n                firstName\n                lastName\n                email\n                image\n                isGuest\n                relationshipToViewer\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "427b228db6973a659f0898fa84700443";

export default node;
